import React from 'react';
import { Link } from 'react-router-dom';
import { Package } from 'lucide-react';

const CollectionList = ({ settings }) => {
    const { title, collections = [], itemsPerRow = 3 } = settings;

    // Map itemsPerRow to grid columns class
    const gridCols = {
        2: 'md:grid-cols-2',
        3: 'md:grid-cols-3',
        4: 'md:grid-cols-4'
    };

    return (
        <section className="py-12 px-4 md:px-8 bg-white">
            <div className="max-w-7xl mx-auto">
                {title && (
                    <h2 className="text-2xl font-bold text-center mb-8 text-slate-900">{title}</h2>
                )}
                <div className={`grid grid-cols-2 ${gridCols[itemsPerRow] || 'md:grid-cols-3'} gap-6`}>
                    {collections.length > 0 ? (
                        collections.map((collectionName, index) => (
                            <Link 
                                key={index} 
                                to={`/products?category=${collectionName}`}
                                className="group block"
                            >
                                <div className="bg-slate-100 aspect-square rounded-lg mb-4 overflow-hidden relative">
                                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-300"></div>
                                    <div className="flex items-center justify-center h-full text-slate-400">
                                        <Package size={48} strokeWidth={1.5} />
                                    </div>
                                </div>
                                <h3 className="font-bold text-slate-900 text-lg group-hover:underline decoration-2 underline-offset-4">
                                    {collectionName}
                                </h3>
                            </Link>
                        ))
                    ) : (
                        // Placeholder if no collections selected
                        [1, 2, 3].map((_, i) => (
                            <div key={i} className="group cursor-pointer">
                                <div className="bg-slate-100 aspect-square rounded-lg mb-4 overflow-hidden relative">
                                    <div className="flex items-center justify-center h-full text-slate-400">
                                        <Package size={48} strokeWidth={1.5} />
                                    </div>
                                </div>
                                <h3 className="font-bold text-slate-900 text-lg">Collection Name</h3>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </section>
    );
};

export default CollectionList;
